interface GameControlsProps {
  notesMode: boolean;
  canUndo: boolean;
  canRedo: boolean;
  hintsEnabled: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onToggleNotes: () => void;
  onAutoNotes: () => void;
  onHint: () => void;
}

export function GameControls({
  notesMode,
  canUndo,
  canRedo,
  hintsEnabled,
  onUndo,
  onRedo,
  onToggleNotes,
  onAutoNotes,
  onHint,
}: GameControlsProps) {
  return (
    <div className="controls">
      <button type="button" onClick={onUndo} disabled={!canUndo}>
        ↶ Undo
      </button>
      <button type="button" onClick={onRedo} disabled={!canRedo}>
        ↷ Redo
      </button>
      <button
        type="button"
        className={notesMode ? 'active' : ''}
        aria-pressed={notesMode}
        onClick={onToggleNotes}
      >
        ✏ Notes {notesMode ? 'on' : 'off'}
      </button>
      <button type="button" onClick={onAutoNotes}>
        Auto-notes
      </button>
      {hintsEnabled && (
        <button type="button" onClick={onHint}>
          💡 Hint
        </button>
      )}
    </div>
  );
}
